/**
 * Receives a string(HTML tags included) and it validates if is a embed code or not
 * @param str - String to be truncate
 * @returns {boolean} Returns the boolean validating the string
 */
export const isEmbedCode = (str: string): boolean => {
  if (/^<iframe.*>/im.test(str) === true
  || /^<object.*>/im.test(str) === true
  || /^<script.*>/im.test(str) === true) {
    return true;
  }
  return false;
};

export const embedCodeMsg: string = 'Please add an embeddable link. If the link is a non-embed URL, it will not be displayed on your connected website.';
